export const surveySummariesSelector = state => state.surveySummaries;
